import React from 'react';
import PropTypes from 'prop-types';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import useApi, { GET_BASE_WIDGETS } from 'hooks/useApi';
import Typography from '@material-ui/core/Typography';
import LoadingSpinner from 'components/LoadingSpinner';

import baseMapping from 'utils/base-widget-mapping';

const useStyles = makeStyles({
  test: {
    cursor: 'pointer',
    '& > div > img': {
      filter: 'blur(1.1px)'
    },
    '&:hover': {
      zIndex: 10,
      transform: 'scale(1.13)',
      '& > div ': {
        boxShadow: '0px 12px 33px 4px rgba(0,0,0,0.53)'
      },
      '& > div > img': {
        filter: 'unset'
      }
    }
  },
  scroll: {
    '&::-webkit-scrollbar': {
      width: '8px'
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'transparent'
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: 'rgba(0, 0, 0, 0.25)',
      backgroundClip: 'padding-box',
      borderRadius: '10px',
      border: `3px solid transparent`
    },
    '&::-webkit-scrollbar-button': {
      width: '0',
      height: '0',
      display: 'none'
    },
    '&::-webkit-scrollbar-corner': {
      display: 'none'
    }
  }
});

const WidgetPreview = ({ handleBaseWidgetClick }) => {
  const classes = useStyles();
  const [state] = useApi(GET_BASE_WIDGETS());
  const { data, isLoading } = state;
  const { data: baseWidgetData } = data || {};
  return (
    <>
      <Box boxShadow={2} height="100%" bgcolor="#fff" display="flex" pl={3}>
        <h4>Add Widget!</h4>
      </Box>
      <Box
        p={2}
        px={5}
        bgColor="#f1f1f1"
        mt={1}
        pb={3}
        className={classes.scroll}
        style={{ maxHeight: '650px', overflowY: 'auto', overflowX: 'hidden' }}
      >
        <Grid container direction="row" justify="space-around" alignItems="center" spacing={2}>
          {isLoading && <LoadingSpinner />}
          {data &&
            baseWidgetData &&
            baseWidgetData.map(widget => (
              <Grid key={widget.id} item xs={12} md={6} className={classes.test}>
                <Box
                  width="100%"
                  p={1}
                  borderRadius={5}
                  bgcolor="#fff"
                  onClick={() => handleBaseWidgetClick(widget.id, widget.img)}
                >
                  <Typography
                    variant="subtitle1"
                    style={{ fontSize: '15px', maxHeight: '33px', overflow: 'hidden' }}
                  >
                    {widget.name}
                  </Typography>
                  <img
                    src={baseMapping[widget.id]}
                    alt=""
                    style={{ maxWidth: '100%', display: 'flex' }}
                  />
                </Box>
              </Grid>
            ))}
        </Grid>
      </Box>
    </>
  );
};

WidgetPreview.propTypes = {
  handleBaseWidgetClick: PropTypes.func.isRequired
};

export default WidgetPreview;
